export const config = {
  API_URL: process.env.REACT_APP_API_URL,
  FILe_URL: process.env.REACT_APP_FILE_URL,
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
};
